// Reading numbers out of results the API computed: picking the value at a month. Display only (plan P2).

import type { RunResult } from "@/api/adapt";
import { idx, N } from "@/lib/months";
import type { ModelNode, Month } from "@/model/types";

/** The value of a monthly series at `m`: months before the grid are 0 (events), after it the last value. */
export function chanceAt(F: ArrayLike<number>, m: Month): number {
	const i = idx(m);
	if (i < 0 || F.length === 0) return 0;
	return F[Math.min(i, F.length - 1)];
}

/** The value at grid index `t`, clamped to the series. */
export function at(a: ArrayLike<number>, t: number): number {
	if (a.length === 0) return NaN;
	return a[Math.min(a.length - 1, Math.max(0, t))];
}

/** A node's headline in a run: an event's chance by `date`, or a metric's likely value then. */
export function headline(node: ModelNode, res: RunResult, date: Month): number | null {
	if (node.kind === "event") {
		const r = res.events[node.id];
		return r ? chanceAt(r.F, date) : null;
	}
	const r = res.metrics[node.id];
	return r ? at(r.q[2], Math.min(N - 1, Math.max(0, idx(date)))) : null;
}

/** The date a node's headline numbers are at. The API resolves it (the node's own, or its default). */
export function heroDate(node: Pick<ModelNode, "headline_date">): Month {
	return node.headline_date;
}
